import { TextField, IconButton } from '@mui/material'
import { ClearIcon } from '@mui/x-date-pickers'
import React from 'react'
import MUIFieldStyles from './MUIFieldWithoutControl.module.scss'

const MUIFieldWithoutControl: React.FC<any> = ({
  name,
  type,
  error,
  label,
  onChange,
  required = false,
  placeholder = '',
  value,
  inputProps,
  showClearIcon = false,
  disabled = false,
  ...props
}) => {
  return (
    <div className={MUIFieldStyles.inputWrapper}>
      <TextField
        label={
          label && (
            <span>
              {label}
              {required && <span style={{ color: '#D4351C' }}>*</span>}
            </span>
          )
        }
        id={name}
        data-testid={name ?? label}
        placeholder={placeholder ?? label}
        variant='outlined'
        inputProps={{
          id: name,
          maxLength: props.maxLength,
          ...inputProps,
        }}
        fullWidth
        type={type}
        error={!!error?.[name]}
        helperText={error?.[name]?.message as string}
        value={value}
        onChange={(event: any) => onChange(event?.target.value)}
        disabled={disabled}
        {...props}
      />
      {value && value.length > 0 && showClearIcon && !disabled && (
        <IconButton
          data-testid='clear-field'
          size='small'
          onClick={() => {
            onChange('')
          }}
          className={MUIFieldStyles.clearBtn}
        >
          <ClearIcon sx={{ height: '1rem', width: '1rem' }} />
        </IconButton>
      )}
    </div>
  )
}

export default MUIFieldWithoutControl
